module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODciIGhlaWdodD0iMTUxIiB2aWV3Qm94PSIwIDAgMTg3IDE1MSI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjcxNCAtMzUpIj48Y2lyY2xlIGN4PSIyMTAuNSIgY3k9IjgwLjUiIHI9IjUwLjUiIG9wYWNpdHk9Ii40Ii8+PGNpcmNsZSBjeD0iLTQuNSIgY3k9IjIxMi41IiByPSI2MC41IiBvcGFjaXR5PSIuNCIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/service-bg-3.svg
// module id = 85
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512